import React from 'react';
import { Button, Icon, Skeleton } from 'antd';
import moment from 'moment';
import { Tag } from 'antd';

export const columnsAPI ={
    getColumns: function({
        setSelectedRow,
    }) {
        return [
            {
                title: 'Protocolo',
                dataIndex: 'protocol',
                key: 'protocol',
                width: '12%',
                ellipsis: true,
                render: (protocol) => protocol || '—',
            },
            {
                title: 'Data',
                dataIndex: 'created_at',
                key: 'created_at',
                className: 'text-center',
                sortDirections: ['descend', 'ascend'],
                defaultSortOrder: 'descend',
                sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
                render: (created_at) => moment(created_at).format('DD/MM/YYYY'),
                width: '10%',
                ellipsis: true,
            },
            {
                title: 'Solicitação',
                dataIndex: 'solicitation_type',
                key: 'solicitation_type',
                width: '25%',
                render: (_, row) => {
                    var summary = row.description || '';

                    if (row.solicitation_type === 'NF-e' && row.custom_data) {
                        var parts = [];
                        var submitter = row.custom_data.submitter;
                        var uploadFile = row.custom_data.upload_file;

                        if (uploadFile) {
                            parts.push('Planilha: ' + uploadFile.original_name);
                        } else if (Array.isArray(row.custom_data)) {
                            var count = row.custom_data.length;
                            parts.push(count + (count === 1 ? ' nota fiscal' : ' notas fiscais'));
                        }

                        if (submitter && submitter.name) {
                            parts.push('por ' + submitter.name);
                        }

                        if (row.is_public) {
                            parts.push('(link público)');
                        }

                        if (parts.length > 0) {
                            summary = parts.join(' · ');
                        }
                    }

                    return (
                    <>
                        <span>{row.solicitation_type}</span><br />
                        <small style={{ color: 'rgba(0,0,0,0.45)' }}>{summary}</small>
                    </>
                    );
                },
                ellipsis: true,
            },
            {
                title: 'Empresa',
                dataIndex: 'customer_id',
                key: 'customer_id',
                width: '30%',
                ellipsis: true,
                render: (_, row) => {
                    if (!row.customer) {
                    return <Skeleton active rows={1}/>;
                    }

                    const appUser = row.customer.app_users && row.customer.app_users.find(appUser => appUser.id === row.app_user_id);

                    return (
                    <>
                        <span>{row.customer.cod} - {row.customer.name}</span><br />
                        <small>{appUser && appUser.name || 'N/A'}</small>
                    </>
                    );
                }
            },
            {
                title: 'Status',
                width: '10%',
                dataIndex: 'status',
                key: 'status',
                filters: [
                    { text: 'Pendente', value: 0 },
                    { text: 'Concluído', value: 1 },
                ],
                onFilter: (value, record) => record.status === value,
                render: (status, record) => {
                    if (record.deleted_at) {
                        return <Tag color="#8c8c8c">Arquivado</Tag>;
                    }
                    var color = status === 0 ? 'volcano' : 'green';
                    var text = status === 0 ? 'Pendente' : 'Concluído';
                    return <Tag color={color}>{text}</Tag>;
                },
            }
        ];
    }
}